import 'css-chunk:src/app/containers/GuestHome/Groups/GroupsPage.scss';export default {};